import { hmmmToEndSlot, hmmmToSlot } from '../config/modeConfig';

export interface Window { start: string; end: string }

/**
 * Default start/end for a counter row added via "Add ctr".
 *
 * With a previous row, the new row starts where it ends. With none, it starts at
 * `fallbackStart` (the owning window's start) — NOT the shift's first slot, which
 * can lie outside the window (e.g. 2200 for a 0230-1000 window) and would force the
 * window to be widened. `overrideEnd` (the next adjacent row's start) wins for the end.
 * `widen` is true when no window contains the start, so the caller should widen one.
 */
export function defaultNewRowRange(opts: {
  prevEnd?: string;
  fallbackStart?: string;
  overrideEnd?: string;
  segs: Window[];
  timeSlots: string[];
  startHour: number;
}): { start: string; end: string; widen: boolean } {
  const { prevEnd, fallbackStart, overrideEnd, segs, timeSlots, startHour } = opts;
  const start = prevEnd ?? fallbackStart ?? timeSlots[0];
  if (overrideEnd) return { start, end: overrideEnd, widen: false };

  let slot = -1;
  try { slot = hmmmToSlot(start, startHour); } catch { /* leave -1 */ }
  const containing = slot >= 0
    ? segs.find(seg => slot >= hmmmToSlot(seg.start, startHour) && slot < hmmmToEndSlot(seg.end, startHour))
    : undefined;
  const end = containing ? containing.end : timeSlots[timeSlots.length - 1];
  return { start, end, widen: !containing && segs.length > 0 };
}
